import React from "react";

import { Box, Typography } from "@mui/material";

/**
 * Formatted MUI component:
 *
 * Title
 * Value
 */
export default function TransparentFragment(props) {
    return (
        <Box
            sx={{
                p: props.p ? props.p : 1,
                m: props.m ? props.m : 1,
                display: "flex",
                flexDirection: props.flexDirection ? props.flexDirection : "column",
                alignItems: props.center ? "center" : "inherit",
                textAlign: props.center ? "center" : "inherit",
                minWidth: props.minWidth ? props.minWidth : "inherit",
                maxHeight: props.maxHeight ? props.maxHeight : "inherit",
                minHeight: props.minHeight ? props.minHeight : "inherit",
                height: props.height ? props.height : "inherit",
                width: props.width ? props.width : "inherit"
            }}>
            {props.title ? (
                <Typography
                    sx={{
                        pb: 1
                    }}
                    variant="h6">
                    {props.title}
                </Typography>
            ) : undefined}
            {props.value}
        </Box>
    );
}
